import script from "./TboHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TboHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TboHeader.vue?vue&type=style&index=0&id=68487e72&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68487e72"]])

export default __exports__